module.exports = __webpack_public_path__ + "961253cb43d85338733ef32444d708cd.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/SocialMedia/components/LikeBlock/images/ic-like-inactive.svg
// module id = 1185
// module chunks = 2